import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { AlertTriangle } from "lucide-react";

export function MaintenanceBanner() {
  const { data: isMaintenanceMode } = useQuery({
    queryKey: ["maintenance-mode"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("admin_api_configs")
        .select("config_value")
        .eq("config_key", "maintenance_mode")
        .maybeSingle();
      
      if (error) return false;
      return data?.config_value === "true";
    },
    refetchInterval: 30000, // Check every 30 seconds
  });

  if (!isMaintenanceMode) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-amber-950 py-3 px-4">
      <div className="container mx-auto flex items-center justify-center gap-2 text-sm font-medium">
        <AlertTriangle className="h-4 w-4" />
        <span>We're currently undergoing scheduled maintenance. Some features may be temporarily unavailable.</span>
      </div>
    </div>
  );
}
